(() => {
  let queue = Promise.resolve();
  const pending = new WeakSet();
  const flag = (node, name) => node.getAttribute(`data-${name}`) === 'true';

  function enqueue(operation) {
    const result = queue.then(operation);
    queue = result.catch(() => {});
    return result;
  }

  function warning(form, button, policy, key) {
    let message = form.querySelector('[data-bk-add-warning]');
    if (!message) {
      message = document.createElement('p');
      message.setAttribute('data-bk-add-warning', '');
      message.setAttribute('role', 'alert');
      message.setAttribute('tabindex', '-1');
      button.insertAdjacentElement('afterend', message);
    }
    message.textContent = policy.getAttribute(`data-${key}`);
    message.hidden = false;
    message.focus({preventScroll: true});
    message.scrollIntoView({block: 'nearest'});
  }

  async function check(form, policy) {
    const url = new URL(window.theme.routes.cart_url, window.location.origin);
    url.searchParams.set('section_id', 'api-cart-items');
    const response = await fetch(url, {cache: 'no-store', credentials: 'same-origin', signal: AbortSignal.timeout(10000)});
    if (!response.ok) throw new Error('Cart check unavailable');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const cart = html.querySelector('[data-bk-cart-policy]');
    const required = ['has-frozen', 'has-nonfrozen', 'has-grill', 'has-food', 'has-unknown'];
    if (!cart || required.some((name) => !['true', 'false'].includes(cart.getAttribute(`data-${name}`)))) {
      throw new Error('Cart classification unavailable');
    }
    const totalCount = cart.getAttribute('data-cart-item-count');
    const classifiedCount = cart.getAttribute('data-rendered-item-count');
    if (!/^\d+$/.test(totalCount || '') || !/^\d+$/.test(classifiedCount || '') || Number(totalCount) !== Number(classifiedCount)) {
      throw new Error('Cart classification incomplete');
    }
    const variant = String(new FormData(form).get('id'));
    const physical = !policy.getAttribute('data-nonshipping-variants').split(',').includes(variant);
    const frozen = physical && flag(policy, 'frozen');
    const nonfrozen = physical && flag(policy, 'nonfrozen');
    if ((flag(policy, 'grill') && flag(cart, 'has-food')) || (flag(policy, 'food') && flag(cart, 'has-grill'))) return 'grill-conflict';
    if ((frozen && nonfrozen) || (frozen && flag(cart, 'has-nonfrozen')) || (nonfrozen && flag(cart, 'has-frozen'))) return 'frozen-conflict';
    if ((frozen && flag(cart, 'has-unknown')) || (physical && !frozen && !nonfrozen && flag(cart, 'has-frozen'))) return 'unknown-conflict';
    return null;
  }

  function run(form, button, add) {
    const policy = form?.querySelector('[data-bk-add-policy]');
    if (!button || button.disabled || pending.has(button)) return Promise.resolve();
    if (!policy) return enqueue(add);
    pending.add(button);
    button.setAttribute('aria-busy', 'true');
    return enqueue(async () => {
      let started = false;
      try {
        if (!form.isConnected || !button.isConnected || button.disabled) return;
        const previous = form.querySelector('[data-bk-add-warning]');
        if (previous) previous.hidden = true;
        const conflict = await check(form, policy);
        if (conflict) {
          warning(form, button, policy, conflict);
          return;
        }
        started = true;
        await add();
      } catch (error) {
        warning(form, button, policy, started ? 'uncertain' : 'retry');
      } finally {
        pending.delete(button);
        button.removeAttribute('aria-busy');
        if (started) {
          button.disabled = false;
          button.classList.remove('is-loading');
        }
      }
    });
  }

  window.BKCartAddGuard = {run, enqueue};
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('form') || !form.querySelector('[data-bk-add-policy]')) return;
    if (event.submitter && !event.submitter.matches('[data-add-to-cart]')) return;
    const button = event.submitter?.matches('[data-add-to-cart]') ? event.submitter : form.querySelector('[data-add-to-cart]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    button.click();
  }, true);
})();
